import { Button } from "@material-ui/core";
import axios from "axios";
import React, {useState} from "react";
import * as XLSX from 'xlsx'
import { constants } from "../Helpers/constantsFile";
import { DateRangeRounded, Description } from "@material-ui/icons";
import { useSelector } from "react-redux";

const parentDivStyle = { display: "flex", alignItems: "center",
justifyContent: "space-between",  gap: "0px", padding: "20px",
background: "white", width: "95%", margin: "auto",
marginTop: "20px", borderRadius: "8px 8px 0px 0px",
flexDirection: "column"
}

const ExcelUpload = () => {
    const token = useSelector(state => state.token.token)
    const myUser = "69182e8eb2899ae5fdc2c6a9"
    const [excelFile, setExcelFile]=useState(null);
    const [excelFileError, setExcelFileError]=useState(null);  
    const [excelData, setExcelData]=useState(null);
    const fileType=["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
    let cashCustomers = []


    const handleSubmit=(e)=>{
        e.preventDefault()
        console.log("It is called")
        if(excelFile!==null){
          console.log("in if again")
          try {
            const workbook = XLSX.read(excelFile, { type: 'buffer' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet=workbook.Sheets[worksheetName];
            const data = XLSX.utils.sheet_to_json(worksheet);
            const sheetName = 'Sheet1'; // Or use workbook.SheetNames[1] to target 'Sheet1' dynamically

            if (workbook.SheetNames.includes(sheetName)) {
              const worksheet = workbook.Sheets[sheetName];
              const data = XLSX.utils.sheet_to_json(worksheet);
              setExcelData(data);
            }
          } catch (error) {
            console.error('Error reading Excel file:', error);
            setExcelData(null); // Set data to null on error
          }
        }
        else{
          console.log("file is null")
          setExcelData(null);
        }
      }

     

    const handleFile = (e)=>{
        let selectedFile = e.target.files[0];
        console.log(selectedFile)
        if(selectedFile){
          // console.log(selectedFile.type);
          if(selectedFile&&fileType.includes(selectedFile.type)){
            let reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);
            reader.onload=(e)=>{
              console.log(e)
              setExcelFileError(null);
              setExcelFile(e.target.result);
            } 
            
        }
        else{
            setExcelFileError('Please select only excel file types');
            setExcelFile(null);
        }
    }
    else{
        console.log('plz select your file');
    }
   
      }

      excelData?.map((data, index) => {
        if (!data["Customer Name"]) return;
    
        const balance = typeof data["REESTO"] === 'number' ? data["REESTO"] : 0;
    
        cashCustomers.push({
            user: myUser,
            name: data["Customer Name"],
            phone: data["Mobile No."]?.toString() || "06150000",
            balance: data["Balance"],
            // damiinName: data["Company"],
            district: data["ADDRESS"]?.toString() || "",
            type: "deynle",
            // monthlyFee: data["LAGA RABO"]
        });
    });
    
    console.log(cashCustomers)

      const loopAndUpload = async (element) => {
        try {
          // First POST request
          const response = await axios.post(`${constants.baseUrl}/customers`, {
            user: element.user,
            name: element.name,
            phone: element.phone,
            // balance: data["Balance Total"],
            damiinName: element.damiinName,
            district: element.district,
            type: element.type
          }, {
            headers: {
              authorization: token
            }
          });
      
          console.log("First response:", response);
      
          // Check if the customer was created successfully
          const createdCustomerId = response?.data?.data?.customer?._id;
          console.log("Created Customer ID:", createdCustomerId);
          
          // if (element.balance < 1) return (console.log("no need for a transaction"))
          if (!createdCustomerId) {
            console.error("Error: Created customer ID is missing.");
            return; // Exit if the customer ID is missing
          }

      
          // Second POST request
          const response2 = await axios.post(
            `${constants.baseUrl}/transactions`,
            {
              user: myUser,
              customer: createdCustomerId,
              description: "Total",
              debit: element.balance,
              date: "2025/11/15"
            },
            {
              headers: {
                authorization: token
              }
            }
          );
      
          console.log("Second response:", response2);
        } catch (error) {
          if (error.response) {
            // Server responded with a status code that falls out of the range of 2xx
            console.error("Error response data:", error.response.data);
            console.error("Error response status:", error.response.status);
            console.error("Error response headers:", error.response.headers);
          } else if (error.request) {
            // Request was made but no response was received
            console.error("Error request:", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error("Error message:", error.message);
          }
          console.error("Error config:", error.config);
        }
      };
      
      


      const uploadHandler = async () =>  {
        console.log(cashCustomers)

         cashCustomers?.forEach(loopAndUpload)
         
      }

      console.log(excelData)


    return (

        <div style={parentDivStyle}>

      <form autoComplete="off"
        onSubmit={handleSubmit}>
          <label><h5>Upload Excel file</h5></label>
          <br></br>
          <input type='file' className='form-control'
          onChange={handleFile} required></input>                  
          {excelFileError&&<div className='text-danger'
          style={{marginTop:5+'px'}}>{excelFileError}</div>}
          <button type='submit' className='btn btn-success'
          style={{marginTop:5+'px'}}>Submit</button>
        </form>

        {excelData?.map(data => {
    if (!data["Customer Name"]) return null;

    // const reestoValue = typeof data["REESTO"] === 'number' ? data["REESTO"] : 0;

    return (
        <div style={{ display: "flex", gap: "20px", width: "40%", justifyContent: "space-between" }}>
            <p>{data['Customer Name']}</p>
            <p>{data['Mobile No.']}</p>
            {/* <p>{`${data['XAFADA']} : ${data['GURI Lr.']}`}</p> */}
            <p>{data['Balance']}</p>
            {/* <p>{reestoValue}</p> */}
        </div>
    );
})}


        <Button onClick = {uploadHandler}
        variant = "contained" style = {{background: "blue"}}>
            Upload
        </Button>

        </div>


    )
}

export default ExcelUpload